import { Button, Input, Select, DatePicker, Row, Col } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from '@ant-design/icons'
import {
  AGE_SEARCH_TYPE,
  COUNTRY_TYPE,
  enabledStatus,
  GENDER_TYPE,
  mncmccOptions,
  PHONE_MODEL,
  retentionDepth,
  source,
  userType,
} from 'src/constants'
import { getGamesCategory, getByCategoriesAll, getGamesByCategory } from 'src/api/game'
import { fetchCountryProvider } from 'src/api/authen'
import { UserNameAutoComplete } from 'src/components/Search/UserNameSearch'
import { getAllGames, getListOfGames } from 'src/api/reports'
import AdsReportSearch from '../Reports/AdsReport/adsReportSearch'
import GameSelect from 'src/components/Search/GameSelect'
import GameSearchSelect from 'src/components/Search/GameSearchSelect'

interface AllGamesReportSearchProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

interface Game {
  id: string
  title: string
}

const AllGamesReportSearch: React.FC<AllGamesReportSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  
  const [isCategoryMapLoading, setIsCategoryMapLoading] = useState(false)
  const [providerCountry, setProviderCountry] = useState('')
  const [userName, setUserName] = useState('')
  const [gameId, setGameId] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [listOfGames, setListOfGames] = useState([])
  const [gameCategory, setGameCategory] = useState('')
  const [listOfCategories, setListOfCategories] = useState([])
  const [categoryMap, setCategoryMap] = useState<Map<string, Set<Game>>>(
    new Map()
  )
 const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');
  const [countries, setCountries] = useState([])
 
  const fetchCategoryMap = async () => {
    try {
      setIsCategoryMapLoading(true)

      const data = await getByCategoriesAll()
      if (data) {
        const map = new Map<string, Set<Game>>()
        data.forEach((category) => {
          if (category.type && Array.isArray(category.games)) {
            category.games.forEach((game) => {
              if (!map.has(category.type)) {
                map.set(category.type, new Set())
              }
              map.get(category.type)?.add({ id: game.id, title: game.title })
            })
          }
        })
        setCategoryMap(map)
      }
    } catch (error) {
      console.error('Error fetching game category:', error)
    } finally {
      setIsCategoryMapLoading(false)
    }
  }

 
  const handleSearchClick = () => {
   
    submitSearchForm()
   
  }


  const filterGamesByType = (type) => {
    const gameSet = categoryMap.get(type?.toUpperCase() ?? '')
    const filteredGames = gameSet ? Array.from(gameSet) : []
    setListOfGames(filteredGames)
    return filteredGames
  }

  const filterGameOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }

  const filterCountryOption = (inputValue, option) => {
    return option.children.toLowerCase().includes(inputValue.toLowerCase())
  }

  const handleSearchTypeClear = React.useCallback(() => {
    appendSearchForm({
      maxAge: '',
      minAge: '',
      searchType: '',
      providerCountry: '',
      userName: '',
      gameId: '',
      startDate: '',
      endDate: '',
      gameCategory: '',
    })

    submitSearchForm()
  }, [])
   

 
  useEffect(() => {
    const fetchGameCategories = async () => {
      try {
        const data = await getGamesCategory()
        if (data) {
          const filteredCategories = data.filter(
            (category) => category !== 'Guys'
          )

          setListOfCategories(filteredCategories)
        }
      } catch (error) {
        console.error('Error fetching game category:', error)
      }
    }
    fetchGameCategories()
    const fetchCountry = async () => {
      try {
        const data = await fetchCountryProvider()
        const countryOptions = data.data.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        }))
        setCountries(countryOptions)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchCountry()
    fetchCategoryMap()
  }, [])

  const filterGameCategoryOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
  const handleCategoryChange = (value) => {
    setGameCategory(value)
    const filteredGames = filterGamesByType(value)
    
      appendSearchForm({
        category: value,
      })
    
  }
const allUserTypeOptions = [
    { label: 'All', value: 'ALL' },
    ...userType,
  ];
 
  
    const handleFilterChange = (value) => {
      setSelectedFilterValue(value);
      let userTypesForSearch;
  
      if (value === 'ALL') {
       
        userTypesForSearch = userType.map(option => option.value);
      } else {
        
        userTypesForSearch = [value];
      }
  
      appendSearchForm({ userAccessType: userTypesForSearch });
      
    };
    
  return (
    <div className="master-search-wrap">
      <Row gutter={15}>
       <Col span={4}>
                 <Select
                   placeholder="Select Category"
                     onChange={handleCategoryChange}
                   filterOption={filterGameCategoryOption}
                   allowClear
                   onClear={() => {
                     setGameCategory('')
                      setListOfGames([])
                     appendSearchForm({ category: '' })
                   }}
                   className="search-input"
                   showSearch
                 >
                   {listOfCategories.map((category) => (
                     <Select.Option value={category} key={category} label={category}>
                       {category.name}
                     </Select.Option>
                   ))}
                 </Select>
               </Col>
        <Col span={4}>
        <GameSearchSelect
    items={gameCategory ? listOfGames : undefined}
    className="search-input"
    style={{ width: '100%' }}
    onChange={(value) => appendSearchForm({ name: value ?? '' })}
  />
         
         
        </Col>
<Col span={4}>
          <Select
            placeholder="Retention Depth"
            onChange={(value) => {
              appendSearchForm({ retentionDepth: value });
              if (!value) submitSearchForm();
            }}
            allowClear
            onClear={() => {
              appendSearchForm({ retentionDepth: '' });
              submitSearchForm();
            }}
            showSearch
            className="search-input"
            style={{ width: '100%' }}
          >
            {retentionDepth.map((country) => (
              <Select.Option value={country.value} key={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={4}>
          <Select
            placeholder="Status"
            onChange={(value) => {
              appendSearchForm({ status: value });
              if (!value) submitSearchForm();
            }}
            allowClear
            onClear={() => {
              appendSearchForm({ status: '' });
              submitSearchForm();
            }}
            showSearch
            className="search-input"
            style={{ width: '100%' }}
          >
            {enabledStatus.map((country) => (
              <Select.Option value={country.value}>
                {country.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={8}>
          <DatePicker.RangePicker
            
            allowClear
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              const startDate = dates?.[0]?.format('YYYY-MM-DD') || null
              const endDate = dates?.[1]?.format('YYYY-MM-DD') || null
              appendSearchForm({ startDate, endDate })
            }}
          />
        </Col>
         <Col span={4}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearchClick}
            className="btn-primary"
            
          >
            Search
          </Button>
        </Col>

      </Row>
      
       

     
    </div>
  )
}

AllGamesReportSearch.displayName = 'AllGamesReportSearch'
export default AllGamesReportSearch
